/* global axios */
import ApiClient from './ApiClient';

class SupportDeskAPI extends ApiClient {
  constructor() {
    super('support_tickets', { accountScoped: true });
  }

  createTicket(data) {
    return axios.post(this.url, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  sendMessage(ticketId, data) {
    return axios.post(`${this.url}/${ticketId}/support_ticket_messages`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  unreadTickets() {
    return axios.get(`${this.url}/unread_count`);
  }

  readTicket(ticketId) {
    return axios.post(`${this.url}/${ticketId}/read`);
  }

  announcements() {
    return axios.get(`${this.baseUrl()}/release_announcements`);
  }

  publishAnnouncement(data) {
    return axios.post(`${this.baseUrl()}/release_announcements`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  readAnnouncement(id) {
    return axios.post(`${this.baseUrl()}/release_announcements/${id}/read`);
  }

  reactToAnnouncement(id, reaction) {
    return axios.post(`${this.baseUrl()}/release_announcements/${id}/react`, {
      reaction,
    });
  }

  unreadAnnouncements() {
    return axios.get(`${this.baseUrl()}/release_announcements/unread_count`);
  }
}

export default new SupportDeskAPI();
